import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  processText: {
    id: 'pages.signup.confirmation.processText',
    defaultMessage: 'Please wait…',
  },
  successText: {
    id: 'pages.signup.confirmation.successText',
    defaultMessage: 'Thanks for confirming your account!',
  },
  login: {
    id: 'pages.signup.confirmation.login',
    defaultMessage: 'Click to log in',
  },
});



// WEBPACK FOOTER //
// ./src/pages/SignupConfirmationPage/messages.js